// Shared sessionStorage handoff so a mobile loginRedirect (which reloads the
// whole app) can send the user back to the page/deep-link they started from.
const KEY = 'postLoginRedirectTarget';
const EXPIRY_MS = 10 * 60 * 1000;

// Only allow same-origin relative paths - a value like "//attacker.example"
// is protocol-relative and would otherwise send window.location.assign off-site.
const isSafeRelativeTarget = (target) => typeof target === 'string'
  && target.startsWith('/')
  && !target.startsWith('//')
  && !/^\/\\/.test(target);

export const setPendingRedirectTarget = (target) => {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify({ target, expiresAt: Date.now() + EXPIRY_MS }));
  } catch {
    // Storage can be unavailable (private mode, sandboxed webview) - the
    // redirect sign-in itself must still be allowed to proceed without it.
  }
};

// Always removes the stored entry so a failed/cancelled/unrelated sign-in
// can never reuse a stale destination.
export const consumePendingRedirectTarget = () => {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return null;
    window.sessionStorage.removeItem(KEY);

    const { target, expiresAt } = JSON.parse(raw);
    if (expiresAt <= Date.now() || !isSafeRelativeTarget(target)) return null;
    return target;
  } catch {
    return null;
  }
};
